import { render, staticRenderFns } from "./LessonCategoriesList.vue?vue&type=template&id=3ee88a93"
import script from "./LessonCategoriesList.vue?vue&type=script&lang=js"
export * from "./LessonCategoriesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports